<template>
    <section>
        <Navbar/>
        <Spinner :color="'text-light'" v-if="isLoading" />
        <div class="calltoaction px-5">          
            <section class="row" v-if="!isLoading">
                <div class="col-md-9 text-center">
                     <div class="card mb-5">
                        <div class="card-header">
                            <h2>
                                <strong>
                                   ISSUE AREA : 
                                </strong>
                                {{leadersVision.issue_area[0]}}
                            </h2>
                        </div>
                        <div class="card-body">
                             <p  class="blog-post-meta pb-4" v-if="author">
                                {{author.date | moment}} by <a href="#">{{author.author}}</a>
                            </p>
                            <p  class="blog-post-meta pb-4" v-if="!author">
                                {{leadersVision.created_at && leadersVision.created_at | moment}} by
                                 <a href="#">{{leadersVision.created_by && leadersVision.created_by.first_name}} {{leadersVision.created_by && leadersVision.created_by.last_name}}</a>
                            </p>
                            <img v-if="author" :src="`${author.image}`" alt="">
                            <p>
                                {{leadersVision.summary}}
                            </p>
                        </div>
                         <div class="card-footer">
                             <div class="d-flex">
                                <a class="p-2" v-if="leadersVision.pdf" :href="`${url()}${leadersVision.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="leadersVision.doc" :href="`${url()}${leadersVision.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="leadersVision.pic" :href="`${url()}${leadersVision.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="leadersVision.video" :href="`${leadersVision.video}`" target="_blank" >Youtube</a>
                            </div>  
                        </div>
                    </div> 
                     <div class="card mb-5">
                        <div class="card-header">
                            <h2>
                                <strong>
                                    CRITIQUE (ANTI-THESIS)
                                </strong>
                            </h2>
                        </div>
                        <div class="card-body">
                             <p  class="blog-post-meta pb-4">
                                {{critique.created_at && critique.created_at | moment}} by <a href="#">{{critique.created_by && critique.created_by.first_name}} {{critique.created_by && critique.created_by.last_name}}</a>
                            </p>
                            <p>
                                {{critique.summary}}
                            </p>
                        </div>
                        <div class="card-footer">
                            <hr>
                             <div class="d-flex">
                                <a class="p-2" v-if="critique.pdf" :href="`${url()}${critique.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="critique.doc" :href="`${url()}${critique.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="critique.pic" :href="`${url()}${critique.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="critique.video" :href="`${critique.video}`" target="_blank" >Youtube</a>
                            </div>  
                        </div>
                    </div> 
                    <div class="card mb-5">
                        <div class="card-header">
                            <h2>
                                <strong>
                                    ENTERPRENEUR'S PLAN (SYNTHESIS)
                                </strong>
                            </h2>
                        </div>
                        <div class="card-body">
                             <p  class="blog-post-meta pb-4">
                                {{resolution.created_at && resolution.created_at | moment}} by <a href="#">{{resolution.created_by && resolution.created_by.first_name}} {{resolution.created_by && resolution.created_by.last_name}}</a>
                            </p>
                            <p>
                                {{resolution.summary}}
                            </p>
                        </div>
                            <div class="card-footer">
                            <hr>
                             <div class="d-flex">
                                <a class="p-2" v-if="resolution.pdf" :href="`${url()}${resolution.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="resolution.doc" :href="`${url()}${resolution.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="resolution.pic" :href="`${url()}${resolution.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="resolution.video" :href="`${resolution.video}`" target="_blank" >Youtube</a>
                            </div>  
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <DebateSidebar/>
                </div>
            </section> 
        </div>
        <FinalFooter />
    </section>
</template>

<script>
/* allow-no-unused-vars */
import moment from 'moment'
import FinalFooter from '../FinalFooter'
import Navbar from '../appBar'
import DebateSidebar from '../debateSidebar'
import challengeAuthors from '../../helpers/challengeAuthors'
import Spinner from '@/components/Spinner'
import url from '../../helpers/url'

    export default {
        name:'debatecritique',
        components:{
            Navbar,
            Spinner,
            DebateSidebar,
            FinalFooter
        },
        
    filters: {
            moment: function (date) {
                return moment(date).format('MMMM Do YYYY');
            }
            },
        data() {
            return {
                author: {},
                resolution:{},
                critique:{},
                enterpreneursPlan:{},
                isLoading:false
            }
        },
        methods:{
            url() {
                return url()
            }, 
            fetchDebateDetails(){
                this.isLoading = true
                this.$store.dispatch('fetchLeadersVision')
                .then(response =>{

                    const challenge = response.data.find(debate => debate.id == this.$route.params.challengeID)
                    this.leadersVision = challenge
                    this.critique = challenge.thinkers_critique[0]
                    this.resolution = this.critique.enterpreneurs_plan[0]
                    const author = challengeAuthors.find(author => author.id == challenge.id)

                     if(!challenge) {
                         this.$router.replace({name:'pageNotfound'})
                     }
                  
                     this.isLoading = false
                    
                })
                .catch(err => {
                    this.isLoading = false
                    //     if(err?.response?.data == undefined) {
                    //     this.toast({
                    //         message:'Network error. Check network connection and try again.',
                    //         type:'error'
                    //     })
                    // }
                    })
            }
    },
    mounted() {
        document.querySelector('body').setAttribute('style', 'background-color:#ba2428')
        this.fetchDebateDetails()
        
    },
    beforeDestroy() {
        document.querySelector('body').removeAttribute('style')
    },
    }
</script>

<style >
 button{
        background-color: #bb3826;
        color:#fff;
        border:1px solid #bb3826;
        padding:10px;
        transition: all 0.5s;
        outline: 0;
        font-size: .9em;
    }
    button:hover, button:active{
        background-color:#ffc106;
        color: #ad5457 ;
    }
    .bg-article{
        background: #bb3826;
    }
.calltoaction{
    padding-top: 150px;
    padding-left: 10px;
    padding-right: 10px;
}
.card-user {
  position: absolute;
  right: 10px;
  top: 10px;
}
.card-category {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
}
h2{
    text-transform: uppercase;
}
  .blog-post-meta {
    margin-bottom: 20px;
    color: #999;
    }
.card-header{
    background-color:#bb3826
}
.card-header h2{
    color:#fff;
}
</style>    